'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var ipfsUnixfs = require('ipfs-unixfs');

var dagPB = require('@ipld/dag-pb');

var sha2 = require('multiformats/hashes/sha2');

var debug = require('debug');

var errCode = require('err-code');

var utils = require('../../../utils.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var log = debug__default["default"]('ipfs:mfs:utils:with-mfs-root');

function loadMfsRoot(_x, _x2) {
  return _loadMfsRoot.apply(this, arguments);
}

function _loadMfsRoot() {
  _loadMfsRoot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, options) {
    var cid$1, buf, _buf, hash;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(options && options.signal && options.signal.aborted)) {
              _context.next = 2;
              break;
            }

            throw errCode__default["default"](new Error('Request aborted'), 'ERR_ABORTED', {
              name: 'Aborted'
            });

          case 2:
            _context.next = 4;
            return context.repo.datastore.open();

          case 4:
            _context.prev = 4;
            _context.next = 7;
            return context.repo.datastore.get(utils.MFS_ROOT_KEY);

          case 7:
            buf = _context.sent;
            cid$1 = cid.CID.decode(buf);
            _context.next = 27;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);

            if (!(_context.t0.code !== 'ERR_NOT_FOUND')) {
              _context.next = 15;
              break;
            }

            throw _context.t0;

          case 15:
            log('Creating new MFS root');
            _buf = dagPB__namespace.encode({
              Data: new ipfsUnixfs.UnixFS({
                type: 'directory'
              }).marshal(),
              Links: []
            });
            _context.next = 19;
            return sha2.sha256.digest(_buf);

          case 19:
            hash = _context.sent;
            cid$1 = cid.CID.createV0(hash);
            _context.next = 23;
            return context.repo.blocks.put(cid$1, _buf);

          case 23:
            if (!(options && options.signal && options.signal.aborted)) {
              _context.next = 25;
              break;
            }

            throw errCode__default["default"](new Error('Request aborted'), 'ERR_ABORTED', {
              name: 'Aborted'
            });

          case 25:
            _context.next = 27;
            return context.repo.datastore.put(utils.MFS_ROOT_KEY, cid$1.bytes);

          case 27:
            log("Loaded MFS root /ipfs/".concat(cid$1));
            return _context.abrupt("return", cid$1);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));
  return _loadMfsRoot.apply(this, arguments);
}

exports.loadMfsRoot = loadMfsRoot;